export const INPUT_MODE_KEY = 'returncenter-input-mode';
export const SELECTED_COMPANY_KEY = 'returncenter-selected-company';

export type StoredCompanySelection = { contextId: string; marketId?: number };

export function getFromLocalStorage<T>(key: string): T | null {
  try {
    const storedJsonString = localStorage.getItem(key);
    return storedJsonString ? JSON.parse(storedJsonString) : null;
  } catch (e) {
    // No user local storage. Do nothing.
  }
  return null;
}

export function persistToLocalStorage<T>(key: string, object: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(object));
  } catch (error) {
    // No user local storage. Do nothing.
  }
}
